import { CustomBottomBar, CustomPageTitle, MinimalStepper } from '@components';
import { Button, Container, Typography } from '@design-system';
// import { Checkbox, Spacing } from '@design-system';
import React from 'react';
import { FaGraduationCap } from 'react-icons/fa';
// import { RiArrowGoBackLine } from 'react-icons/ri';
// import SignatureCanvas from 'react-signature-canvas';
import './FormationTalkEmargementPage.scss';
import { useFormationTalkEmargementPageVM } from './useFormationTalkEmargementPageVM';
import { UserDropdown } from '@components/UserDropdown/UserDropDown';

export const FormationTalkEmargementPage: React.FC = () => {
    const {
        errorMessage,
        pageTitle,
        // isSomeoneElse,
        // handleIsSomeoneElseChange,
        // signatureCanvasRef,
        // handleClearSignature,
        // setIsEmpty,
        handleClickSave,
        isDisabled,
        // requestUser,
        // handleRequestUserChange,
        instructorName,
        handleInstructorNameChange
    } = useFormationTalkEmargementPageVM();

    if (errorMessage) {
        return (
            <Container>
                <Typography intrinsic="p" color="red">
                    {errorMessage}
                </Typography>
            </Container>
        );
    }

    return (
        <div className="formation-talk-emargement-page">
            {pageTitle && (
                <CustomPageTitle>
                    <Typography intrinsic="h3" iconColor="blue" icon={<FaGraduationCap />} iconFilled iconSize={20}>
                        {pageTitle}
                    </Typography>
                </CustomPageTitle>
            )}

            <Container className="emargement-page-header" radius="none" column>
                <Typography intrinsic="h2" className="mb-large-spacing">
                    Emargement
                </Typography>
                <MinimalStepper
                    steps={[
                        { label: 'Les instructions', status: 'completed' },
                        { label: 'Le quizz', status: 'completed' },
                        { label: 'Emargement', status: 'inProgress' }
                    ]}
                />
            </Container>

            <Container>
                <Container className="emargement-page-content" padding="medium large" bordered="grey">
                    <Typography intrinsic="h4" className="mb-large-spacing">
                        Informations
                    </Typography>

                    <div className="mb-large-spacing">
                        <Typography intrinsic="p" color="marine" className="mb-medium-spacing">
                            Nom de la personne ayant fait passer la formation
                        </Typography>
                        <UserDropdown
                            onChangeAction={(userId: string) => handleInstructorNameChange(userId)}
                            value={instructorName}
                            valueKey="label"
                        />
                    </div>

                    <Typography intrinsic="h4" className="mb-large-spacing">
                        Signature digitale
                    </Typography>
                    <Typography intrinsic="p" color="marine" className="mb-large-spacing">
                        Veuillez signer le document ci-dessous pour valider votre emargement.
                    </Typography>

                    <Typography intrinsic="p" color="grey">
                        En appuyant sur « Signer », vous attestez avoir pris connaissance de la formation qui vous a été présentée, en avoir
                        compris le contenu et avoir validé vos connaissances à travers le quiz associé.
                    </Typography>
                </Container>

                {/* <Container className="emargement-page-content mt-medium-spacing" padding="medium large" bordered="grey">
                    <Checkbox
                        checked={isSomeoneElse}
                        onChange={handleIsSomeoneElseChange}
                        label="Cette formation a été réalisée par quelqu'un d'autre que moi"
                    />
                    {isSomeoneElse && (
                        <div className="mt-medium-spacing">
                            <UserDropdown
                                onChangeAction={(userId: string) => handleRequestUserChange(userId)}
                                value={requestUser}
                                valueKey="id"
                            />

                            <SignatureCanvas
                                throttle={24}
                                velocityFilterWeight={1}
                                penColor="black"
                                canvasProps={{
                                    className: 'sigCanvas'
                                }}
                                onEnd={() => setIsEmpty(false)}
                                ref={signatureCanvasRef}
                            />
                            <Spacing />
                            <div className="buttons">
                                <Button
                                    icon={<RiArrowGoBackLine />}
                                    iconSize={25}
                                    onClick={handleClearSignature}
                                    iconColor="green"
                                    variant="secondary"
                                    color="green"
                                    className="refresh-signature-button"
                                >
                                    <></>
                                </Button>
                            </div>
                        </div>
                    )}
                </Container> */}
            </Container>

            <CustomBottomBar>
                <Button variant="primary" color="green" onClick={handleClickSave} size="fullwidth" disabled={isDisabled}>
                    <Typography intrinsic="h4">Signer</Typography>
                </Button>
            </CustomBottomBar>
        </div>
    );
};
